import React from "react";
import Style from "../../styles/js/Styles";

export default function AlertItem({ alert }) {
  const style = Style();

  const location = (alert) => {
    return (
      "Latitud: " +
      alert.state.location.latitude +
      ", Longitud: " +
      alert.state.location.longitude
    );
  };

  return (
    <div>
      <div className={style.rowList}></div>
      <div className={style.rowList}>
        <div>
          Nombre de usuario: {alert.profile.name} {alert.profile.lastName}{" "}
        </div>
      </div>
      <div className={style.rowList}>
        <div>Telefono: {alert.profile.phoneNumber} </div>
      </div>
      {alert.state.location !== undefined ?
        (
          <div><div className={style.rowList}>
          <div>Latitud: {alert.state.location.latitude} </div>
        </div>
        <div className={style.rowList}>
          <div>Longitud: {alert.state.location.longitude } </div>
        </div>
        </div>
        ) : (
          <div className={style.rowList}>
            <div>Ubicación desconocida</div>
          </div>
        )
      }
    </div>
  );
}
